export const AUTHENTICATED_ROUTES = {
    HOMEPAGE_ROUTE: '/',
    PORTFOLIOS_ROUTE: '/portfolios',
    PORTFOLIOS_CONFIRM_SAVE_ROUTE: '/portfolios/confirm/:confirmSave',
    PORTFOLIO_CREATE_ROUTE: '/portfolios/create',
    PORTFOLIO_CREATE_STEP_ROUTE: '/portfolios/create/:step',
    PORTFOLIO_CREATE_WITH_FUND_ROUTE: '/portfolios/create/withfund/:fundid',
    PORTFOLIO_EDIT_ROUTE: '/portfolios/edit/:id',
    PORTFOLIO_EDIT_STEP_ROUTE: '/portfolios/edit/:id/:step',
    PORTFOLIO_ADD_TO_ROUTE: '/portfolios/addto/:id',
    PORTFOLIO_DETAILS_ROUTE: '/portfolios/details/:id',
    PORTFOLIO_DETAILS_INVESTORS_ROUTE: '/portfolios/details/:id/investors',
    PORTFOLIO_DETAILS_REPORTS_ROUTE: '/portfolios/details/:id/reports/:type',
    PORTFOLIO_SUBMIT_ROUTE: '/portfolios/submit/:id',
    PORTFOLIO_SUBMITTED_ROUTE: '/portfolios/submitted/:id',
    PORTFOLIO_TRACKING_ROUTE: '/portfolios/tracking/:id',
    PORTFOLIO_SUMMARY_ROUTE: '/portfolios/summary/:id',
    LIBRARYOFFUNDS_ROUTE: '/libraryoffunds',
    LIBRARYOFFUNDS_ITEM_ROUTE: '/libraryoffunds/:id',
    LIBRARYOFFUNDS_ITEM_DATAROOM_ROUTE: '/libraryoffunds/:id/datarooms',
    SETTING_ROUTE: '/settings'
}

export const UNAUTHENTICATED_ROUTES = {
    HOMEPAGE_ROUTE: '/'
}